import React from 'react';
import {Link as RouterLink, withRouter} from 'react-router-dom';
import Panel from '../components/Panel';
import './Home.scss';
import {Progress} from 'reactstrap';
import store, {actions} from '../store';
import blueprintDefinitions from '../lib/blueprint.definition';
import helpers from '../lib/helpers';
import _ from 'lodash';

class Home extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
    };

    this.redirect = this.redirect.bind(this);
    this.calculateBlueprintStats = this.calculateBlueprintStats.bind(this);
  }

  async componentDidMount() {

    this.taskCounts = {};
    _.forEach(blueprintDefinitions, (value, key) => {
      this.taskCounts[key] = value.reduce((sum, block) => {
        return sum + block.fields.length;
      }, 0);
    });

    let blueprints = await store.dispatch(actions.blueprints.fetchAll());
    blueprints = blueprints.map(this.calculateBlueprintStats);
    this.setState({
      initializing: false,
      blueprints,
    });
  }

  calculateBlueprintStats(blueprint) {

    let stats = _.reduce((blueprint.values || {}),(summary, value, key) => {
      if (value.submitted) {
        summary.completed++;
      }
      if (_.isEmpty(value.data)) {
        summary.pending++;
      }
      return summary;
    }, {completed: 0, overdue: 0, pending: 0});

    stats.completedPercentage = Math.round((stats.completed * 100) / this.taskCounts[blueprint.type] );
    blueprint.stats = stats;

    return blueprint;
  }



  redirect(path) {
    return function(e) {
      e.stopPropagation();
      this.props.history.push(path);
    }.bind(this);
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : [
      <Panel title="Here's what you can do" key="main-panel">
        <div className="row">
          <div className="col-md-6">
            <div className="skipbox darkblue"
                 onClick={this.redirect('/blueprints/submit')}>
                    <span className="img-bg">
                      <img src={process.env.PUBLIC_URL +
                      '/img/document-icon.svg'} alt="" height={36}/>
                    </span>
              <span className="skiptext">
                        <RouterLink to="/blueprints/submit"
                                    onClick={(e) => e.stopPropagation()}>Submit Document</RouterLink>
                        <p>Here you can submit all your documents pertaining to a project</p>
                    </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="skipbox green"
                 onClick={this.redirect('/discussions')}>
                    <span className="img-bg">
                      <img src={process.env.PUBLIC_URL + '/img/upload-icon.svg'}
                           height={36}
                           alt=""/>
                    </span>
              <span className="skiptext">
                        <RouterLink to="/discussions"
                                    onClick={(e) => e.stopPropagation()}>Start a Discussion</RouterLink>
                        <p>All discussions are stored here for easy referral and follow up.</p>
                    </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="skipbox liteblue"
                 onClick={this.redirect('/blueprints/review')}>
                    <span className="img-bg">
                      <img
                          src={process.env.PUBLIC_URL + '/img/viewdoc-icon.svg'}
                          height={36}
                          alt=""/>
                    </span>
              <span className="skiptext">
                        <RouterLink to="/blueprints/review"
                                    onClick={(e) => e.stopPropagation()}>Review Document</RouterLink>
                        <p>
                          Have a look at all documents you have submitted and review pending items before the due date. You may also leave a comment if you have any questions.
                        </p>
                    </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="skipbox orange"
                 onClick={this.redirect('/faq')}
            >
                    <span className="img-bg">
                      <img src={process.env.PUBLIC_URL + '/img/visit-icon.svg'}
                           height={36}
                           alt=""/>
                    </span>
              <span className="skiptext">
                        <RouterLink to="/faq"
                                    onClick={(e) => e.stopPropagation()}>Visit FAQ</RouterLink>
                        <p>
                          Have a question? Check out our FAQ to get the answers.
                        </p>
                    </span>
            </div>
          </div>
        </div>
      </Panel>,
      <div className="row" key="bottom-row">
        <div className="col-md-7">
          <Panel title="My Projects" className="Home--MyProjects">
            <div className="row table-head">
              <div className="col-md-4">
                Project Name
              </div>
              <div className="col-md-4">
                Progress
              </div>
              <div className="col-md-4">
                Actions
              </div>
            </div>
            {
              this.state.blueprints.map((blueprint) => {
                let percentage = blueprint.stats.completedPercentage;
                let color = 'success';
                if(percentage > 75){
                  color = 'success';
                } else  if(percentage > 25){
                  color = 'warning';
                } else {
                  color = 'error';
                }
                return (
                    <div className="row table-row" key={blueprint.blueprintId}>
                      <div className="col-md-4">
                        {blueprint.name}
                      </div>
                      <div className="col-md-4">
                        <Progress value={percentage} color={color}>{percentage}%</Progress>
                      </div>
                      <div className="col-md-4">
                        <RouterLink to={`/blueprints/review/${blueprint.groupId}/${blueprint.blueprintId}`}>Review
                          Blueprint</RouterLink>
                      </div>
                    </div>
                );
              })
            }
          </Panel>
        </div>
      </div>,
    ];
  }
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/containers/Home.js